import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import WordCarousel from "./WordCarousel";
import ContactUsButton from "./ReusableComponents/ContactUsButton";

const Container = styled.div``;

const Title = styled.h1`
  text-align: center;
  margin: 0 0 16px 0;
  color: rgb(104 38 85);
  @media (max-width: 700px) {
  }
`;

const Homepage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Container className="Homepage">
      <Title>{t("company.slogan").toUpperCase()}</Title>
      <WordCarousel />
      <ContactUsButton/>
    </Container>
  );
};

export default Homepage;
